// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import { createStore } from '@atlassian/react-sweet-state';
import actions from './actions.tsx';
import type { State } from './types.tsx';

const initialState: State = {
	collapseStart: new Set(),
	collapseEnd: new Set(),
	expandStart: new Set(),
	expandEnd: new Set(),
};

export default createStore<State, typeof actions>({
	name: 'navigation-ui',
	initialState,
	actions,
});
